import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Navbar from "../../../Components/Common/navbar";
import { giftService } from "../../../api/services/gift.service";
import { useAuthContext } from "../../../Components/AuthContext";
import MobileViewContainer from "../../../Components/MobileViewContainer";
import PromotionGiftLayout from "../../Promotion/components/PromotionGiftLayout";
import { mapGiftVoucherItem } from "../components/giftPageMappers";

const GiftVoucherPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const { isUserLogin } = useAuthContext();

  const [voucherItem, setVoucherItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const fetchGiftData = () => {
    setIsLoading(true);
    setError(null);

    giftService
      .getVoucherShareGift(id)
      .then((response) => {
        setVoucherItem(response.data);
      })
      .catch((e) => {
        console.log(e);
        setError(e);
        setVoucherItem(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (!isUserLogin) {
      setVoucherItem(null);
      setError(null);
      setIsLoading(false);
      return;
    }

    fetchGiftData();
  }, [isUserLogin, id]);

  const mappedItem = mapGiftVoucherItem(voucherItem);

  const handlePrimaryAction = () => {
    if (!isUserLogin) {
      navigate(`/login?path=${location.pathname}`);
      return;
    }

    if (!voucherItem || mappedItem.isReceived || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    giftService
      .putReceiveVoucherGift(id)
      .then(() => {
        toast.error("선물을 받았습니다.");
      })
      .catch((e) => {
        console.log(e);
        toast.error("선물을 받을 수 없습니다.");
      })
      .finally(() => {
        setIsSubmitting(false);
        if (isUserLogin) {
          fetchGiftData();
        }
      });
  };

  return (
    <MobileViewContainer>
      <Navbar />
      <PromotionGiftLayout
        {...mappedItem}
        isLoggedIn={isUserLogin}
        isLoading={isLoading}
        isSubmitting={isSubmitting}
        isReceived={mappedItem.isReceived}
        onPrimaryAction={handlePrimaryAction}
        error={error}
        loggedOutMessage="로그인 하여 선물을 확인하세요."
        hideSiteSectionWhenEmpty={true}
      />
    </MobileViewContainer>
  );
};

export default GiftVoucherPage;
